import React, { useEffect, useState } from 'react';
import { Page, Button } from 'shared';
import { routePaths } from 'services/routing';
import { Redirect } from 'react-router-dom';
import './ehr.scss';
import { getSubscription, SubsriptionType } from 'preferences/billing/Subscription';
import { useSelector } from 'react-redux';
import { getIsOrgMember, getSSN, getIdentity, getIsIAL2Verified, getCwOrganizationId, getNpiNumber, getOrgName } from 'identity/selectors';
import IdMeVerificationErrorModal from './IdMeVerificationErrorModal';
import MedicalDataTable from './MedicalDataTable';
import { isMobile, openRouteInApp, isIOS } from 'mobile/helpers';
import HealthNavigationNew from './HealthNavigationNew';
import HealthNavigationIas from './HealthNavigationIas';
const env = window.env || {};


export default function EHR(props) {
  const [redirect, setRedirect] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [email, setEmail] = useState(null);
  const currentSubscription = getSubscription();
  const identity = useSelector(getIdentity);
  const cwOrgId = useSelector(getCwOrganizationId);
  const npi = useSelector(getNpiNumber);
  const orgName = useSelector(getOrgName);
  const ssn = useSelector(getSSN);
  const isIAL2Verified = useSelector(getIsIAL2Verified);
  const isOrgMember = useSelector(getIsOrgMember);
  // const isIdMeAuth = localStorage.getItem('isIdMeAuth') === 'true';
  const isFreetire = currentSubscription.type == SubsriptionType.Free;

  function doPayment() {
    setRedirect(true);
  }

  function closeConfirm() {
    setIsConfirmOpen(!isConfirmOpen);
  }

  function verifyIAL2() {
    localStorage.setItem('IAL2Verification', true);
    if (isMobile && isIOS) {
      // skip
      var iosRedirect = false;
    }
    else {
      if (window.location.search) {
        localStorage.setItem('IAL2VerificationRedirect', window.location.href.replace(window.location.search, ''));
      } else {
        localStorage.setItem('IAL2VerificationRedirect', window.location.href);
      }
    }
    const verificationUrl = env.Idme_verificationurl || "https://api.id.me/oauth/authorize?client_id=b11fffd9e80a78bd9ebfa479024de747&redirect_uri=https://applinkidme.calciumhealth.com/KSgPp05XIwb&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2";
    if (isMobile) {
      openRouteInApp(verificationUrl);
    }
    else {
      window.location.href = verificationUrl;
    }
  }

  // async function verifyIAL2() {
  //   try {
  //     localStorage.setItem('IAL2Verification', true);
  //     const redirectUrl = window.location.search
  //       ? window.location.href.replace(window.location.search, '')
  //       : window.location.href;
  //     localStorage.setItem('IAL2VerificationRedirect', redirectUrl);

  //     const verificationUrl = env.Idme_verificationurl;
  //     if (isMobile) {
  //       await openRouteInApp(verificationUrl);
  //     } else {
  //       window.location.href = verificationUrl;
  //     }
  //   } catch (error) {
  //     console.error('IAL2 verification redirect failed:', error);
  //     window.location.href = env.Idme_verificationurl;
  //   }
  // }


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    if (error && error.includes('access_denied')) {
      setIsConfirmOpen(true);
    }
    if (identity) {
      setEmail(identity.email);
    }
  }, []);

  console.log(identity);

  return (
    <Page
      id='invoice-list'
      backPath={{ to: props.location?.state?.backpath ?? routePaths.root }}
      centerElement='Electronic Health Records'>
      <div className="menu_container">
        {isOrgMember ? <div className='menuBars'><HealthNavigationNew ssn={ssn} email={email} npi={npi} orgName={orgName} cwOrgId={cwOrgId} /></div> : null}
        {isFreetire && !isOrgMember ? (
          <div className='upgradePlanInfo'>
            <div className='upgradePlanInfo-text'>
              Upgrade your subscription to access your electronic health records from your hospitals and healthcare providers!
            </div>
            <div className='form-row claim-offer-btn upgrade-button'>
              <Button id='subscribe-button' className="button blue btn btn-primary" onClick={doPayment}>Upgrade</Button>
            </div>
          </div>
        ) : null}
        {!isFreetire && !isOrgMember && !isIAL2Verified ? (
          <div className='verify-container'>
            <div>
              To ensure that your health data and privacy are fully protected and secure, we must verify your identity to NIST-IAL2 standards, which will require contact information, a government-issued photo ID and a smart phone. We use ID.me to conduct this easy, but necessary process.
            </div>
            <div className='form-row claim-offer-btn upgrade-button' style={{ cursor: 'pointer' }}>
              <img onClick={verifyIAL2} height={45} src="/static/images/verifyidme.svg" alt="android iphone verifyidme" />
            </div>
          </div>
        ) : null}
        {!isFreetire && !isOrgMember && isIAL2Verified ? <div className='menuBars'><HealthNavigationIas ssn={ssn} /></div> : null}
        {isConfirmOpen ? <IdMeVerificationErrorModal isConfirmOpen={isConfirmOpen} closeConfirm={closeConfirm} /> : null}
      </div>
      {redirect ? <Redirect to='/view-plan' /> : null}
    </Page>
  );
}
